<template>
<div></div>
</template>

<script>
export default {
  methods: {
    isValid () {
      return true
    },
    isModified () {
      return false
    },
    hasAddedFiles () {
      return false
    },
    hasRemovedFiles () {
      return false
    },
    getAddedFiles () {
      return []
    },
    getRemovedFiles () {
      return []
    },
    getModifiedFiles () {
      return []
    },
    cleanAddedFiles () {},
    cleanRemovedFiles () {},
    cleanModifiedFiles () {},
    startLoading () {},
    finishLoading () {}
  }
}
</script>
